<template>
  <div class="slide carousel-wrapper">
    <slick ref="slick" :options="slickOptions">
      <div
        v-for="(i, index) in slides"
        :key="index"
        class="img-wrapper"
        @click="viewSlide(i)"
      >
        <router-link
          to=""
          :href="i.url"
          :title="i.tool_tip"
          class="slide__image"
        >
          <img width="100%" :src="i.image" />
        </router-link>
      </div>
    </slick>
  </div>
</template>

<script>
import Slick from 'vue-slick'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import 'slick-carousel/slick/slick.css'
import { mapGetters } from 'vuex'
export default {
  data: () => {
    return {
      slickOptions: {
        centerMode: true,
        centerPadding: '20px',
        focusOnSelect: true,
        infinite: true,
        slidesToShow: 1,
        speed: 500,
        dots: true,
        arrows: false,
        swipe: true,
      },
    }
  },
  components: { Slick },
  created() {
    if (this.$route.path !== '/login') {
      this.$store.dispatch('SLIDE_REQUEST')
    }
  },
  beforeUpdate() {
    if (this.$refs.slick) {
      this.$refs.slick.destroy()
    }
  },
  updated() {
    this.$nextTick(function() {
      if (this.$refs.slick) {
        this.$refs.slick.create(this.slickOptions)
      }
    })
  },
  computed: {
    ...mapGetters(['SLIDES']),
    slides() {
      return this.$store.getters.SLIDES
    },
  },
  methods: {
    viewSlide(url) {
      window.open(url.url)
    },
  },
}
</script>

<style lang="scss">
.slide {
  &__image {
    border-radius: 40px;
    overflow: hidden;
    display: block;
  }
}
.slick {
  &-slide {
    padding: 0 10px;
  }
  &-dots {
    top: -32px;
    bottom: auto;
    li {
      button {
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background: #cccccc;
        padding: 0;
        &:before {
          display: none;
        }
      }
      &.slick-active {
        button {
          width: 20px;
          height: 5px;
          background: #414141;
          margin-left: -6px;
          border-radius: 7px;
        }
      }
    }
  }
}
.slick-slide.slick-active.slick-center.slick-current .slide__image {
  border-radius: 40px;
}
ul.slick-dots {
  padding-left: 0;
}
.carousel-wrapper {
  .v-application {
    line-height: 0;
  }
}
</style>
